export class Responsabile {
  documentoIdentificador: string;
  nomeContato: string;
  email: string;
  senha: string;
  termoAceite: boolean;
  dataNascimento: string;
}

export class Entidade {
  documentoIdentificador: string;
  tipoEntidade: string;
  razaoSocial: string;
  codigoDdi: string;
  telefone: string;
  celular: string;
}
